import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Badge } from "@/components/ui/badge";
import { PlaySquare, Layers, Award } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function CourseCatalog() {
  const [courses, setCourses] = useState(null);
  const refCode = new URLSearchParams(window.location.search).get("ref");
  const refSuffix = refCode ? `?ref=${refCode}` : "";

  useEffect(() => {
    axios.get(`${API}/api/public/courses`).then((r) => setCourses(r.data || [])).catch(() => setCourses([]));
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="course-catalog-page">
      <div className="bg-slate-900 text-white">
        <div className="max-w-5xl mx-auto px-4 py-12 text-center">
          <Badge className="bg-orange-500 text-white border-0 mb-4">We Speak Spanish CR</Badge>
          <h1 className="text-3xl md:text-4xl font-bold">Cursos de español on-demand</h1>
          <p className="text-slate-300 mt-3 max-w-xl mx-auto">Aprendé a tu propio ritmo con cursos grabados por nuestros profesores: videos, prácticas, quizzes y certificado al finalizar.</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-10">
        {courses === null ? (
          <div className="text-center text-slate-400">Cargando…</div>
        ) : courses.length === 0 ? (
          <div className="text-center text-slate-500 py-16" data-testid="catalog-empty">Pronto publicaremos nuevos cursos. ¡Volvé pronto!</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.map((c) => (
              <Link key={c.id} to={`/cursos/${c.id}${refSuffix}`} className="group rounded-2xl border border-slate-200 overflow-hidden hover:shadow-lg transition-shadow bg-white" data-testid={`catalog-course-${c.id}`}>
                <div className="relative aspect-video bg-slate-100">
                  {c.cover_url ? (
                    <img src={`${API}${c.cover_url}`} alt={c.title} className="absolute inset-0 h-full w-full object-cover transition-transform group-hover:scale-105" loading="lazy" />
                  ) : (
                    <div className="absolute inset-0 flex items-center justify-center"><PlaySquare className="h-10 w-10 text-slate-300" /></div>
                  )}
                  {c.level && <Badge className="absolute top-2 left-2 bg-white/90 text-slate-700 border-0">{c.level}</Badge>}
                </div>
                <div className="p-5">
                  <h2 className="font-semibold text-slate-900 leading-snug group-hover:text-orange-600 transition-colors">{c.title}</h2>
                  {c.subtitle && <p className="text-sm text-slate-500 mt-1 line-clamp-2">{c.subtitle}</p>}
                  <div className="flex items-center gap-3 text-xs text-slate-500 mt-3">
                    <span className="inline-flex items-center gap-1"><Layers className="h-3.5 w-3.5" /> {c.module_count} módulos · {c.lesson_count} lecciones</span>
                    <span className="inline-flex items-center gap-1"><Award className="h-3.5 w-3.5" /> Certificado</span>
                  </div>
                  <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between">
                    <div className="text-lg font-bold text-slate-900">{c.price === 0 ? <span className="text-emerald-600">Gratis</span> : `$${Number(c.price).toFixed(0)} USD`}</div>
                    <span className="text-sm font-medium text-orange-600">Ver curso →</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
